import React, { useState } from 'react';
import FormModalFormatter, { IFormModalFormatterProps } from './FormModalFormatter';
import getIn from '../../connectedForm/utils/getIn';

const LazySalesInvoiceForm = React.lazy(() => import('../../../views/salesLedger/SalesInvoiceForm'));

const SalesInvoiceFormModalFormatter = ({ value, dependentValues }: IFormModalFormatterProps) => {
  const [modalOpen, setModalOpen] = useState(false);

  const idValue = getIn(dependentValues.rowData, dependentValues.options?.entityId);

  return (
    <FormModalFormatter modalOpen={modalOpen} setModalOpen={setModalOpen} value={value}>
      <LazySalesInvoiceForm
        forceReadOnly={true}
        onClose={() => {
          setModalOpen(false);
        }}
        pageView={true}
        match={{ params: { id: idValue } }}
        overrideParams={{ id: idValue }}
      />
    </FormModalFormatter>
  );
};

export default SalesInvoiceFormModalFormatter;
